<template>
  <span class="spinner" role="presentation" />
</template>

<style scoped lang="scss">
.spinner {
  border: 4px solid rgb(255 255 255 / 30%);
  border-radius: 50%;
  border-top-color: #fff;
  display: block;
  height: 4rem;
  width: 4rem;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
